export default __webpack_public_path__ + "static/media/trust.83e33177.png";